import type { SurveyEditableField } from "../types/surveyForm.types";

export const PRESET_POINTS = [100, 200, 300, 400, 500, 750, 1000, 1250, 1500] as const;

export const POINT_OPTIONS = [
  ...PRESET_POINTS.map((value) => ({
    value: String(value),
    label: String(value),
  })),
  {
    value: "custom",
    label: "Custom Value",
  },
];

export const PUBLISHED_EDITABLE_FIELDS: SurveyEditableField[] = [
  "title",
  "description",
  "endTime",
];

export const SURVEY_FIELD_ERROR_CLASS_NAME = "border-red-500 dark:border-red-500";
